export const typeOfAlertZeroResultsDialog = 'typeOfAlertZeroResultsDialog';
